import React from "react";
import PageBannerAbout from "../../images/poster-about-page.jpeg";
import AboutPageMedia from "../../images/About us_Rapidops Website.mp4";

export const mainBannerObj = {
  classes: "about-banner",
  header: (<>About Us</>),
  position: "left",
  content: (<><p>High-quality engineering, proven expertise, teamwork and <br/>commitment to your success</p></>),
  buttonText: "Get in touch",
  link: "form-section",
  scrollSection: "about-partner-section",
  mediaType: "video",
  mediaSource: AboutPageMedia,
  mediaClass: "",
  mediaPoster: PageBannerAbout,
  bottomGap: ""
};

